module.exports = __webpack_public_path__ + "static/CircularStd-Book-9d1891ccb5d7184f7c99396a8e224d05.ttf";